var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRouter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1560_7183)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.485 37.4222H12.465M20.8328 37.4222H20.8128M31.2476 20.7265V29.0744M37.1739 14.8204C36.3986 14.0442 35.478 13.4285 34.4646 13.0084C33.4511 12.5883 32.3649 12.3721 31.2678 12.3721C30.1708 12.3721 29.0845 12.5883 28.0711 13.0084C27.0577 13.4285 26.137 14.0442 25.3618 14.8204M43.059 8.91425C39.9283 5.78558 35.6833 4.02808 31.2572 4.02808C26.8312 4.02808 22.5862 5.78558 19.4555 8.91425M8.2911 29.0744H41.6824C43.9876 29.0744 45.8563 30.9431 45.8563 33.2483V41.5961C45.8563 43.9013 43.9876 45.77 41.6824 45.77H8.2911C5.98591 45.77 4.11719 43.9013 4.11719 41.5961V33.2483C4.11719 30.9431 5.98591 29.0744 8.2911 29.0744Z",
    stroke: "url(#paint0_linear_1560_7183)",
    strokeWidth: 4.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1560_7183",
    x1: 24.9868,
    y1: 4.02808,
    x2: 24.9868,
    y2: 45.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1560_7183"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white",
    transform: "translate(0.988281 0.897705)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRouter);
export default __webpack_public_path__ + "static/media/Router.daa39f58a0dc070c55f6d4249d844c54.svg";
export { ForwardRef as ReactComponent };